import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "original-detection-list app-page app-page--fill" }
const _hoisted_2 = { class: "page-toolbar" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "table-container" }

import { ref, reactive, onMounted, onUnmounted, nextTick } from 'vue'
import { ElMessage } from 'element-plus'
import { Refresh } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
import { list } from '@/network/index'
import DynamicTable from '@/components/DynamicTable.vue'
import { useDetailStore } from '@/store/detailStore'
import { getMenuChildPathByComponent, getMenuPathByComponent } from '@/utils/menuRoute'
import { useRouteTitle } from '@/utils/useRouteTitle'
import { useButtonPermission } from '@/utils/buttonPermission'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const detailStore = useDetailStore()
const pageTitle = useRouteTitle('原始检测数据列表')
const { canAny } = useButtonPermission('/RawDataManagement/OriginalDetectionList/index.vue')

// 表格引用
const dynamicTableRef = ref<InstanceType<typeof DynamicTable> | null>(null)

// 响应式数据
const loading = ref(false)
const tableData = ref<any[]>([])

// 接口响应数据
const apiResponse = ref<any>(null)

// model数据，用于表格表头展示
const tableModel = ref<Record<string, string> | undefined>(undefined)

// 分页
const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)

// 表格最大高度
const tableMaxHeight = ref<number>(500)

// 计算表格最大高度
const calculateTableHeight = () => {
  nextTick(() => {
    const windowHeight = window.innerHeight
    tableMaxHeight.value = windowHeight - 380
  })
}

// 分页配置
const paginationConfig = reactive({
  show: true,
  get page() { return currentPage.value },
  get pageSize() { return pageSize.value },
  get total() { return total.value },
  pageSizes: [10, 20, 50, 100],
  layout: 'total, sizes, prev, pager, next, jumper',
  small: true
})

// 表头字段中文映射
const columnLabels: Record<string, string> = {
  '编码': '编码',
  '名称': '名称',
  '开始时间': '开始时间',
  '最后更新时间': '更新时间',
  '完成时间': '完成时间',
  '提交人员': '提交人员',
  '检验人员': '检验人员',
  '校核人员': '校核人员'
}

// 筛选参数
const filterParams = ref<any[]>([])



// 分页变化
const handlePageChange = (page: number) => {
  currentPage.value = page
  loadData()
}

const handlePageSizeChange = (size: number) => {
  pageSize.value = size
  currentPage.value = 1
  loadData()
}

// 加载数据
const loadData = async () => {
  try {
    loading.value = true
    console.log('发送请求参数:', { page: currentPage.value, intPageSize: pageSize.value })
    console.log('筛选和排序参数:', filterParams.value)
    
    const res = await list.listIndex({ page: currentPage.value, intPageSize: pageSize.value }, filterParams.value)
    
    if (res && res.status === 200 && res.success && res.response && res.response.data) {
      tableData.value = res.response.data
      total.value = res.response.dataCount || res.response.data.length
      apiResponse.value = res
      // 从接口返回中提取model数据
      if (res.response.model && typeof res.response.model === 'object') {
        tableModel.value = res.response.model;
      } else {
        tableModel.value = undefined;
      }
      
      ElMessage.success(`数据加载成功，共 ${res.response.dataCount} 条记录`)
    } else {
      ElMessage.error('数据加载失败')
      tableModel.value = undefined
    }
  } catch (error) {
    console.error('加载数据失败:', error)
    ElMessage.error('数据加载失败')
  } finally {
    loading.value = false
  }
}


// 刷新按钮点击事件
const handleRefresh = () => {
  loadData()
}

// 排序处理函数
const handleSort = (column: string, type: number) => {
  console.log('排序:', column, type === 1 ? '升序' : '降序')
  // 排序参数会通过filter事件一起传递，这里不需要额外处理
  // 因为DynamicTable组件已经将排序和筛选参数合并后通过filter事件发送
}

// 筛选处理函数（现在也处理排序参数）
const handleFilter = (filters: any[]) => {
  console.log('筛选和排序参数:', filters)
  filterParams.value = filters
  currentPage.value = 1 // 重置到第一页
  loadData() // 重新加载数据
}

// 详情按钮点击事件
const handleDetail = (row: any) => {
  console.log('查看详情:', row)
  const listPath = getMenuPathByComponent(
    '/RawDataManagement/OriginalDetectionList/index.vue',
    '/原始数据管理/原始检测数据列表'
  )
  const detailPath = getMenuChildPathByComponent(
    '/RawDataManagement/OriginalDetectionList/index.vue',
    '原始检测数据详情',
    '/原始数据管理/原始检测数据列表/原始检测数据详情'
  )
  
  // 将参数存储到store中
  detailStore.setDetailParams(row.Id, listPath)
  
  // 跳转到详情页面，通过query参数传递ID
  router.push({
    path: detailPath,
    query: { id: row.Id }
  })
}

// 组件挂载时加载数据
onMounted(() => {
  loadData()
  calculateTableHeight()
  window.addEventListener('resize', calculateTableHeight)
})

onUnmounted(() => {
  window.removeEventListener('resize', calculateTableHeight)
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { class: "main-card" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(pageTitle)), 1),
          _createVNode(_component_el_button, {
            type: "primary",
            circle: "",
            size: "small",
            class: "app-refresh-btn",
            icon: _unref(Refresh),
            loading: loading.value,
            onClick: handleRefresh,
            title: "刷新"
          }, null, 8, ["icon", "loading"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(DynamicTable, {
            data: tableData.value,
            model: tableModel.value,
            loading: loading.value,
            "max-height": tableMaxHeight.value,
            "show-column-selector": true,
            "show-export": true,
            "show-detail-button": _unref(canAny)('详情', '现场照片下载', '原始数据excel下载', '数据变更'),
            pagination: paginationConfig,
            "column-labels": columnLabels,
            onDetail: handleDetail,
            onSort: handleSort,
            onFilter: handleFilter,
            onPageChange: handlePageChange,
            onPageSizeChange: handlePageSizeChange,
            ref_key: "dynamicTableRef",
            ref: dynamicTableRef
          }, null, 8, ["data", "model", "loading", "max-height", "show-detail-button", "pagination"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})